import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToggleNavbar } from "../../Redux/Actions/uiActions";
import logo from "../../assets/Kevin/my logo A.png";

import "../Styles/NavModalTooltip.css";
import { FullItemsNavbar } from "./FullItemsNavbar";
import { ItemsNavbar } from "./ItemsNavbar";
import { HiMenu } from "react-icons/hi";

export const Navbar = () => {
  const { showSidebar } = useSelector((state) => state.ui);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setToggleNavbar(!showSidebar));
  };
  return (
    <>
      <nav className="nav fixed w-full top-0 z-50 select-none flex items-center justify-between flex-wrap bg-gray-800  shadow-xl transition-all ease-in-out duration-700 "
      >
        {!showSidebar && (
          <div className="flex md:hidden text-white">
                  <HiMenu
              className="mx-3 text-2xl font-bold cursor-pointer"
              onClick={handleClose}
            />
          </div>
        )}

        <div className="hidden md:flex w-2/5 sm:w-4/12 md:w-3/12 lg:w-2/12 text-white font-bold text-2xl m-4 sm:m-3">
          <img loading='lazy' className="w-14 mx-0" src={logo} alt="icon-user" />
        </div>

        {showSidebar ? (
          <div className="animate__animated animate__fadeInLeft flex mt-4">
            <FullItemsNavbar />
          </div>
        ) : (
          <div className="animate__animated animate__fadeInLeft flex mt-4">
            <ItemsNavbar />
          </div>
        )}
      </nav>
    </>
  );
};
